<div *ngIf="showStats">
  <ion-button fill="outline" (click)="showStats = !showStats">Show Video</ion-button>
  <sc-stats-for-nerds></sc-stats-for-nerds>
</div>
<div *ngIf="!showStats" class="preview-video-container">
  <div class="preview-stat-overlay">
    <ion-button
      *ngIf="studioSession$?.value.confType !== 'daily'"
      class="overlay-stat-toggle"
      fill="clear"
      (click)="showStats = !showStats"
      tooltip="Show Stats">
      <ion-icon src="/assets/icons/24px/nerd.svg" slot="icon-only"></ion-icon>
    </ion-button>
    <div class="badge-list">
      <sc-mini-notification
        @fadeInOut
        color="{{
          netStats.mos && netStats.mos < 2
            ? 'error'
            : (netStats.mos && netStats.mos < 3) || netStats.serverPing > 300
            ? 'warning'
            : 'success'
        }}"
        *ngIf="netStats.serverPing"
        icon="{{
          netStats.mos && netStats.mos < 2
            ? '/assets/icons/24px/wifi-error.svg'
            : netStats.mos && netStats.mos < 3
            ? '/assets/icons/24px/wifi-very-weak.svg'
            : (netStats.mos && netStats.mos < 4) || netStats.serverPing > 300
            ? '/assets/icons/24px/wifi-weak.svg'
            : netStats.mos && netStats.mos < 5
            ? '/assets/icons/24px/wifi-strong.svg'
            : '/assets/icons/24px/wifi-very-strong.svg'
        }}">
        <span *ngIf="netStats.mos"> ({{ netStats.mos }}/5) </span>
        Ping: {{ netStats.serverPing }} ms
      </sc-mini-notification>
      <sc-mini-notification
        @fadeInOut
        *ngIf="audioStats.packetsLost || audioStats.jitter > 30"
        icon="/assets/icons/24px/sound.svg"
        color="warning">
        <span *ngIf="audioStats.jitter">Jitter: {{ audioStats.jitter.toFixed(0) }}ms</span>
        <span *ngIf="audioStats.packetsLost">, Lost: {{ audioStats.packetsLost }}</span>
      </sc-mini-notification>
      <sc-mini-notification
        @fadeInOut
        color="warning"
        *ngIf="netStats.qualityLimitationReason !== 'none'"
        icon="/assets/icons/24px/wifi-error.svg">
        Quality Limitation: {{ netStats.qualityLimitationReason }}
      </sc-mini-notification>
    </div>
  </div>
  <sc-player
    [mediaStream]="videoStream"
    [audioStream]="audioStream"
    [placeholderName]="name$ | async"
    [placeholderPhotoURL]="(user$ | async)?.photoURL"
    [muted]="mute$ | async"
    [mirrored]="true"
    [videoOff]="videoOff$ | async"
    [showControls]="true"></sc-player>
</div>
